// import { css } from '@emotion/core'
import styled from '@themes/theme'

export const MissionWrap = styled.div`
  display: block;

  .mission-notice {
    padding: 11px;
    text-align: center;
    font-size: ${props => props.theme.font.medium};
    color: ${props => props.theme.color.gray};
    background: ${props => props.theme.color.contentsBg};
  }

  .mission-list{
    &--item {
      position: relative;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 70px;
      margin-top: 1px;
      padding: 10px 14px;
      background: ${props => props.theme.color.contentsBg};
      border-radius: 0;

      &--reward {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 55px;
        height:50px;
        border-radius: 6px;
        background: ${props => props.theme.color.mainBg};
        overflow: hidden;

        &--img, > svg {
          position: static; /* 수령 완료시 ::before 배경 뒤에 위치하도록 */
          width: auto;
          height: 33px;
          /* 보상 완료 이미지 */
          &.received-img {
            display: none;
            position:absolute;
            top: 50%;
            left: 50%;
            height: 57px;
            transform: translate(-50%,-50%);
          }
        }
      }
      &--mission-txt {
        position: absolute;
        top: 50%;
        left: 85px;
        transform: translate(0, -50%);
      }

      &--reward-status {
        display: inline-block;
        width: 77px;
        height: 28px;
        line-height: 2.8rem;
        border-radius: 50px;
        color: ${props => props.theme.color.disableTxt};
      }
      /* 미션 달성 - 미수령 */
      &.achievement {
        background: #292519;
        border: 2px solid #B79A25;
        .mission-list--item--reward-status {
          color: ${props => props.theme.color.yellow};
        }
      }
      /* 미션 보상 수령 완료 */
      &.received {
        background: ${props => props.theme.color.subBg};
        .mission-list--item--reward {
          &::before {
            content:'';
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            display: block;
            width: inherit;
            height: inherit;
            background: ${props => props.theme.color.mainBg};
            opacity: .7;
          }
          .received-img {
            display: block;
          }
        }
        .mission-list--item--mission-txt {
          color: ${props => props.theme.color.disableTxt};
        }
      }
    }
  }
`
